import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["inputField", "textDisplay", "menu"];

  connect() {
    this.isReadOnly = this.data.get("readOnly") === "true";

    if (this.hasInputFieldTarget) {
      this.inputFieldTarget.addEventListener(
        "keypress",
        this.handleKeyPress.bind(this)
      );
    }

    document.addEventListener("click", (event) => {
      if (!this.element.contains(event.target)) {
        this.closeMenu();
      }
    });
  }

  leftClick(event) {
    this.closeMenu();
    this.edit();
  }

  openMenu(event) {
    event.preventDefault();
    if (this.isReadOnly || !this.hasMenuTarget) return;

    const menu = this.menuTarget;
    menu.style.display = "block";
    menu.style.left = `${event.offsetX}px`;
    menu.style.top = `${event.offsetY}px`;
  }

  closeMenu() {
    if (this.hasMenuTarget) {
      this.menuTarget.style.display = "none";
    }
  }

  menuEdit() {
    this.closeMenu();
    this.edit();
  }

  menuRemove() {
    this.closeMenu();
    if (this.hasInputFieldTarget) {
      this.inputFieldTarget.value = "";
    }
    this.edit();
  }

  edit() {
    if (this.isReadOnly) return;

    if (!(this.hasTextDisplayTarget && this.hasInputFieldTarget)) return;

    const displayElement = this.textDisplayTarget;
    const inputElement = this.inputFieldTarget;

    displayElement.style.display = "none";
    inputElement.style.display = "block";
    inputElement.focus();
  }

  handleKeyPress(event) {
    if (event.key === "Enter") {
      event.preventDefault();
      this.inputFieldTarget.blur();
    }
  }

  save(event) {
    if (!(this.hasInputFieldTarget && this.hasTextDisplayTarget)) return;

    const inputElement = this.inputFieldTarget;
    const displayElement = this.textDisplayTarget;
    const newValue = inputElement.value.trim();

    const urlPattern = /^(https?:\/\/(.*))+|^(\{\{?[^{}]*\}?)$/;

    if (newValue !== "" && !urlPattern.test(newValue)) {
      alert("Please enter a valid URL");
      return;
    }

    const { accountId, projectId, taskListId, taskId, blockId } = this.element.dataset;

    fetch(`/${accountId}/projects/${projectId}/task_lists/${taskListId}/tasks/${taskId}/task_blocks/${blockId}/update_content`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content
      },
      body: JSON.stringify({ task_block: { value: newValue } })
    })
      .then(response => response.json())
      .then(data => {
        if (data.success) {
          if (data.value) {
            const escapeHtml = (text) => {
              const div = document.createElement('div');
              div.textContent = text;
              return div.innerHTML;
            };
            
            const escapedUrl = escapeHtml(data.value);
            const copyUrlText = document.querySelector('meta[name="i18n-copy_url"]')?.content || 
                               document.querySelector('meta[name="i18n-app.blocks.copy_url"]')?.content || 
                               'Copy URL';
            const copiedText = document.querySelector('meta[name="i18n-copied"]')?.content || 
                              document.querySelector('meta[name="i18n-app.tasks.copied"]')?.content || 
                              'Copied';
            
            displayElement.innerHTML = `
              <a target="_blank" href="${escapedUrl}" class="url-link">${escapedUrl}</a>
              <span data-controller="copy-link"
                    data-copy-link-content="${escapedUrl}"
                    data-copy-link-success-message="${escapeHtml(copiedText)}"
                    data-target="copy-link.linkText"
                    class="copy_button tiny-link"
                    data-action="click->copy-link#copy">${escapeHtml(copyUrlText)}</span>
            `;
            
            if (window.Stimulus) {
              const copyButton = displayElement.querySelector('[data-controller="copy-link"]');
              if (copyButton) {
                window.Stimulus.load(copyButton);
              }
            }
          } else {
            displayElement.innerHTML = "";
          }
        }
      })
      .finally(() => {
        inputElement.style.display = "none";
        displayElement.style.display = "flex";
      });
  }
}
